import { useTranslation } from "react-i18next";
import { Checkbox } from "@/components/ui/checkbox";
import { Skeleton } from "@/components/ui/skeleton";
import { usePeopleSearch } from "@/contexts/PeopleSearchContext";
import { useLists } from "@/hooks/lists/useLists";

export function ListsPanel() {
	const { t } = useTranslation();
	const { draft, updateDraft } = usePeopleSearch();
	const { data: lists, isLoading } = useLists();

	const toggleList = (listId: string, checked: boolean) => {
		const ids = checked
			? [...draft.lists.ids, listId]
			: draft.lists.ids.filter(id => id !== listId);
		updateDraft('lists', { ids });
	};

	if (isLoading)
		return (
			<div className="space-y-2">
				{Array.from({ length: 5 }).map((_, i) => (
					<Skeleton key={i} className="h-6 w-full" />
				))}
			</div>
		);

	return (
		<div className="space-y-4">
			<p className="text-sm text-muted-foreground">
				{t("peopleSearch.lists.hint", "Candidates who are members of any selected list")}
			</p>
			<div className="space-y-1">
				{(lists || []).map(list => (
					<label key={list.id} className="flex items-center gap-2 px-1 py-1.5 rounded-sm hover:bg-muted cursor-pointer">
						<Checkbox
							checked={draft.lists.ids.includes(list.id)}
							onCheckedChange={checked => toggleList(list.id, !!checked)}
						/>
						<span className="text-sm flex-1 truncate">{list.name}</span>
						<span className="text-xs text-muted-foreground">{list.candidate_count}</span>
					</label>
				))}
				{(lists || []).length === 0 && (
					<p className="text-sm text-muted-foreground px-1 py-2">
						{t("peopleSearch.lists.empty", "No lists yet")}
					</p>
				)}
			</div>
		</div>
	);
}
